var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSlide(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 3 2 C 1.895 2 1 2.895 1 4 L 1 16 C 1 17.105 1.895 18 3 18 L 10 18 L 10 20 L 9 20 C 8.448 20 8 20.448 8 21 C 8 21.552 8.448 22 9 22 L 15 22 C 15.552 22 16 21.552 16 21 C 16 20.448 15.552 20 15 20 L 14 20 L 14 18 L 21 18 C 22.105 18 23 17.105 23 16 L 23 4 C 23 2.895 22.105 2 21 2 L 3 2 z M 3 4 L 21 4 L 21 16 L 3 16 L 3 4 z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlide);
export default __webpack_public_path__ + "static/media/slide.fbbbc2f5fc7f8e384efe2757b979d7f2.svg";
export { ForwardRef as ReactComponent };